import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Heart = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.5 10c0-1.459 1.228-2.946 2.434-2.946m8.626-2.936A4.94 4.94 0 0 0 12 7.183a4.94 4.94 0 0 0-4.566-3.065C4.71 4.118 2.5 6.835 2.5 9.565c0 5.966 8.233 10.817 9.5 10.817s9.5-4.851 9.5-10.817c0-2.73-2.21-5.447-4.94-5.447"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Heart) as SvgIcon;
export { ForwardRef as ReactComponent };
